

import jsCookie from 'js-cookie';


export function getToken() {
  return jsCookie.get('token');
}

function getCookieDomain(): string | undefined {
  const hostname = window.location.hostname.toLowerCase().replace(/\.$/, '');
  if (hostname === 'dauyan.net' || hostname.endsWith('.dauyan.net')) {
    return '.dauyan.net';
  }
  if (hostname === 'dauyan.com' || hostname.endsWith('.dauyan.com')) {
    return '.dauyan.com';
  }
  return undefined;
}

function removeAuthCookie(name: string): void {
  const options = {path: '/'};
  jsCookie.remove(name, options);
  const domain = getCookieDomain();
  if (domain) {
    jsCookie.remove(name, {...options, domain});
  }
}

/** Clears organization-specific cookies without changing the authenticated token. */
export function clearOrganizationScopeCookies(): void {
  ['org', 'organization_id', '_org'].forEach(removeAuthCookie);
}

/** Clears the prior student session before a fixed organization login. */
export function clearStudentSessionCookies(): void {
  removeAuthCookie('token');
  clearOrganizationScopeCookies();
}

/** Stores organization scope only after a fixed entry is confirmed by the server. */
export function setFixedOrganizationCookies(orgKey: string, organizationId: string): void {
  const options = {path: '/'};
  clearOrganizationScopeCookies();

  const domain = getCookieDomain();
  const sharedOptions = domain ? {...options, domain} : options;
  jsCookie.set('org', orgKey, sharedOptions);
  jsCookie.set('organization_id', organizationId, sharedOptions);
  jsCookie.set('_org', orgKey, options);
}
